/** CMS personal document types that benefit from PP-Structure table extraction. */
const TABLE_EXTRACTION_TYPES = new Set(["education_document"]);

/**
 * PP-Structure table OCR is very slow on CPU (~5–10 min). Education marks are
 * parsed from Paddle text lines by default. Set REACT_APP_OCR_USE_TABLE_API=true
 * to force the legacy table endpoint.
 */
export const needsTableExtraction = (documentType) => {
  if (process.env.REACT_APP_OCR_USE_TABLE_API === "true") {
    return Boolean(documentType && TABLE_EXTRACTION_TYPES.has(documentType));
  }
  return false;
};
